import { TipoMensajeURLPath } from 'src/enums/EscritosLegales'

export const TipoEscritos = [
  TipoMensajeURLPath.ASUNTO,
  TipoMensajeURLPath.EJECUCION,
  TipoMensajeURLPath.PERSONACION,
  TipoMensajeURLPath.QUEJA,
  TipoMensajeURLPath.MONITORIO,
  TipoMensajeURLPath.SENTENCIA,
  TipoMensajeURLPath.TRAMITE
]
